import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, JSON_KEY_CODE, TABLE_HEADER_CODE, TABLE_HEADER_DESCRIPTION, JSON_KEY_DESCRIPTION, JSON_KEY_STATUS,
   TABLE_HEADER_STATUS, ConvertStatus, DROPDOWN_LIST_NONE, AddItemToDropdown,
   UPDATE_ROW,
   DELETE_ROW,
   instrumentCodeColor,
   rowOpacityForStatus,
   statusTextColor} 
from '../../common/common';
import { Modal } from 'react-bootstrap';
import ExchangesAdminForm from '../forms/exchanges_admin_fom';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { addExchange } from '../../redux/dropDownSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

const Exchanges = () => {
   const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownExchangeData, setDropDownExchangeData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);
   
   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[ExchangesTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[ExchangesTable] Row Double Clicked:`, rowData);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('Exchanges handler, data: ', details.data);
   
      const modifiedRow = {
         ...details.data,
         id: details.data.code,
         status: ConvertStatus(details.data.status),      
      };

      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prev => {
               const exists = prev.some(row => row.id === modifiedRow.id);
               if (exists) {
                  console.log(`Duplicate message with id ${modifiedRow.id} ignored.`);
                  return prev;
               }
               return [...prev, modifiedRow];
            });
            dispatch(addExchange({ id: modifiedRow.code, name: modifiedRow.code })); // Add for drop down lists
            AddItemToDropdown(setDropDownExchangeData, { id: details.data.code, name: details.data.code });
            break;

         case UPDATE_ROW:
            setLocalTableData(prevData => prevData.map(row => row.id === modifiedRow.id ? modifiedRow : row));
            break;

         case DELETE_ROW:
            setLocalTableData(prevData => prevData.filter(row => row.id !== modifiedRow.id));
            break;

         default:
            console.log('Unknown event type:', details.type);
            break;
      }
   }, [dispatch]);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);

   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID }, // don't show it but it is still there
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="ExchangesTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}

         />
            
         <Modal show={showForm} onHide={handleCloseForm}>
            <ExchangesAdminForm rowData={selectedRow} onClose={handleCloseForm} exchangeOptions={dropDownExchangeData} />
         </Modal>
      </>
      
   );
};

export default Exchanges;
